import dayjs from 'dayjs';

const TWENTY_THREE_HOURS_IN_MS = 82800000; // 60s * 60m * 23hr * 1000ms

/**
 * @param {string} path
 */
export const isLiveBlogPath = (path) => {
  if (!path) return false;

  return path.split('/')[3] === 'live-blog';
};

/**
 * @param  {string} subType
 * @returns {boolean}
 */
export const shouldRenderRegularBlog = (subType) => subType === 'blog';

/**
 * @param {string} path
 */
export const isSingleCardRoute = (path) => /ncrd\d+$/.test(path);

/**
 * @param {string | null} [flag]
 * @returns {boolean}
 */
export const isBlogEventEnded = (flag) => (
  !!flag
  && typeof flag === 'string'
  && flag.toLowerCase() === 'event ended'
);

// N.B. - we use 23 hours because there are 24 hours in 1 day and live blogs need to be closed within 1 day for SEO purposes.
// If 24 hours elapse, we must mark an event ended and editors must create a new Live Blog.
/**
 * @param {string} dateVal
 * @returns {boolean}
 */
export const isBlogLive = (dateVal) => {
  if (!dateVal) return false;
  return Date.now() - new Date(dateVal).getTime() < TWENTY_THREE_HOURS_IN_MS;
};

/**
 * Checks if a live blog is live.
 *
 * @param {object} args
 * @param {string | null} [args.latestDate] Last card publish date.  This is used as as a fallback if other factors are inconclusive.
 * @param {string | null} [args.flag] The flag set by the editor.
 * @param {string | null} [args.eventDateTimeEndsAt] If a valid date is supplied, this is used to determine if the live blog is live.
 * @returns {boolean}
 */
export function isLiveBlogLive({ latestDate, flag, eventDateTimeEndsAt }) {
  const useEventEndedFromCmsData = typeof eventDateTimeEndsAt === 'string' && dayjs(eventDateTimeEndsAt).isValid();

  if (useEventEndedFromCmsData) {
    return dayjs().isBefore(eventDateTimeEndsAt);
  }

  // Need date value from an item to check
  if (!latestDate) {
    return false;
  }

  // Editor has entered "event ended" in the article flag
  // Else use last card publish date to determine live
  return isBlogEventEnded(flag) ? false : isBlogLive(latestDate);
}
